import { render, staticRenderFns } from "./QDropdown.vue?vue&type=template&id=2d82dae1&scoped=true"
import script from "./QDropdown.vue?vue&type=script&lang=js"
export * from "./QDropdown.vue?vue&type=script&lang=js"
import style0 from "./QDropdown.vue?vue&type=style&index=0&id=2d82dae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82dae1",
  null
  
)

/* custom blocks */
import block0 from "./QDropdown.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports